module.exports = __webpack_public_path__ + "img/receipt28.a53a3ec1.png";